<template>
  <BaseStickyFooter
    :is-visible="show"
    class="position-relative pt-md pb-lg">
    <template #content>
      <div class="w-100 d-flex flex-column align-items-center row-gap-lg">
        <BaseButton
          :text="buttonText"
          :to="nextScreenRouterLink"
          :tracking-name="buttonText"
          :tracking-data="{
            screen: currentScreen?.name ?? 'unknown',
            location: 'Sign Up Page Footer'
          }"
          class="next-button"
          @click="emit('next', $event)"/>
        <slot name="additional-content"/>
      </div>
    </template>
  </BaseStickyFooter>
</template>

<script setup>
import { useSignUpNavigationStore } from '@/stores/signUpNavigation.js'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import BaseStickyFooter from '@shared/components/ADORN/BaseStickyFooter.vue'
import { storeToRefs } from 'pinia'
import { computed, toValue } from 'vue'

const signUpNav = useSignUpNavigationStore()
const { currentScreen, nextScreenRouterLink } = storeToRefs(signUpNav)
const show = computed(() => toValue(currentScreen.value.footer?.show) ?? false)
const buttonText = computed(() => currentScreen.value.footer?.buttonText ?? 'Next')

const emit = defineEmits(['next'])
</script>

<style lang="scss" scoped>
.next-button {
  width: 100%;
  max-width: 300px;
  @include media-tablet-or-larger {
    max-width: 415px;
  }
}
</style>
